export default __webpack_public_path__ + "static/media/coffee.32d671a9.svg";